import type { Notification } from "../types/notification.types.ts"

// One collapsed row can hold read and unread updates at once, so it survives
// while something unread is left in it, re-headed on the newest of those.
export function keepUnreadMembers(row: Notification): Notification | null {
  const members = row?.group_members

  // An empty list is not a group: the row answers for itself.
  if (!members?.length) return row?.unread ? row : null

  const unread = members.filter((member) => member?.unread)
  if (!unread.length) return null

  const [head] = unread
  if (unread.length === 1) return { ...head, group_count: 1 }

  return { ...head, group_count: unread.length, group_members: unread }
}
